import { WalletError, type ApiClient } from '@cef-ai/wallet-api-client';
import type { Identity } from '@cef-ai/wallet-identity';
import type { HostToPopup, PopupToHost } from '@cef-ai/wallet';

export interface FindApplicationsHandlerDeps {
  identity: Identity;
  apiClient: ApiClient;
  send: (msg: PopupToHost) => void;
}

export function createFindApplicationsHandler(deps: FindApplicationsHandlerDeps) {
  return async (
    msg: Extract<HostToPopup, { type: 'wallet:findApplications' }>,
    _meta: { origin: string },
  ): Promise<void> => {
    if (!deps.identity.isAuthenticated) {
      throw new WalletError('unauthorized', 'findApplications: not logged in');
    }
    const address = deps.identity.addresses!.cere;
    const result = await deps.apiClient.applications.find({ address, appId: msg.appId });
    deps.send({ type: 'wallet:result', id: msg.id, result });
  };
}
